import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Flex,
  Heading,
  Link,
  // eslint-disable-next-line no-restricted-imports
  Button as ChakraButton,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { RevealOnScroll } from '../../../atoms/RevealOnScroll';
import { useContactModal } from 'src/hooks/useContactModal';
import { ContactModal } from 'src/components/molecules/ContactModal';
import { TRACK_ISSUES_STEPS } from 'src/features/MP/utils/constants';
import { ResourcePageStep } from '../../../molecules/ResourcePageStep';

const TrackIssuesPage: React.FC = () => {
  const { onOpen, modalProps } = useContactModal({
    defaultInterest: 'pricing',
    title: 'Start Modeling',
    submitButtonText: 'Start Modeling',
  });

  const { onOpen: onOpenSales, modalProps: salesModalProps } = useContactModal({
    defaultInterest: 'sales',
    title: 'Contact Sales',
    submitButtonText: 'Contact Sales',
  });

  return (
    <>
      <Box bg="white" color="text.darkBlue.900" fontFamily="marketingPage">
        <Container maxW="container.xl" pt={{ base: 8, md: 16 }}>
          <RevealOnScroll>
            {/* Breadcrumb */}
            <HStack
              spacing={4}
              mb={4}
              fontSize="16px"
              color="text.darkBlue.800"
              fontWeight="500">
              <Link
                as={RouterLink}
                to="/resources"
                opacity="0.6"
                _hover={{ opacity: 1, textDecoration: 'underline' }}
                cursor="pointer">
                Resources & Docs
              </Link>
              <Text>/</Text>
              <Text>Track Issues</Text>
            </HStack>

            {/* Header */}
            <VStack align="start" spacing={4} mb={{ base: 12, md: 24 }}>
              <Text fontSize={{ base: '24px', md: '40px' }} fontWeight="700">
                TRACK ISSUES
              </Text>
              <Text
                fontSize="15px"
                color="text.darkBlue.800"
                fontFamily="marketingPage"
                fontWeight="normal">
                Keep goals visible and progress transparent.
              </Text>
            </VStack>
          </RevealOnScroll>

          {/* Steps */}
          <VStack spacing={0} align="stretch" mb={32}>
            {TRACK_ISSUES_STEPS.map((step, index) => (
              <ResourcePageStep
                key={step.number}
                step={step}
                isLast={index === TRACK_ISSUES_STEPS.length - 1}
                showNumber={true}
              />
            ))}
          </VStack>

          <RevealOnScroll>
            {/* Call to Action Section */}
            <VStack spacing={4} px={4} textAlign="center" mb={48}>
              <Heading
                color={'text.darkBlue.900'}
                fontSize={{ base: '2xl', md: '3xl', lg: '4.5xl' }}
                textTransform="uppercase"
                fontFamily="marketingPage">
                Ready to get real answers <br /> from your data?{' '}
              </Heading>
              <Text
                fontSize={{ base: 'lg', md: 'xl' }}
                color="text.darkBlue.800"
                fontWeight={500}>
                Start modeling with AI-powered insights or talk to <br />
                our team to find the best setup for your business.
              </Text>
              <Flex
                direction={{ base: 'column', sm: 'row' }}
                gap={4}
                w={{ base: '100%', sm: 'auto' }}>
                <ChakraButton
                  onClick={onOpen}
                  size="lg"
                  bg={'icon.green'}
                  color="white"
                  fontWeight="bold"
                  fontFamily="marketingPage"
                  borderRadius="8px"
                  px={8}
                  w={{ base: '100%', sm: 'auto' }}
                  _hover={{ bg: 'icon.green.500' }}>
                  Start modeling
                </ChakraButton>
                <ChakraButton
                  onClick={onOpenSales}
                  size="lg"
                  bg={'background.lightGrey'}
                  border="1px solid #F0F0F0"
                  color="text.darkBlue.900"
                  fontFamily="marketingPage"
                  borderRadius={8}
                  px={8}
                  py={4}
                  w={{ base: '100%', sm: 'auto' }}>
                  Contact Sales &nbsp; →
                </ChakraButton>
              </Flex>
            </VStack>
          </RevealOnScroll>
        </Container>
      </Box>
      <ContactModal {...modalProps} />
      <ContactModal {...salesModalProps} />
    </>
  );
};

export default TrackIssuesPage;
